import { render, staticRenderFns } from "./AddToQuarantineModal.vue?vue&type=template&id=1af1f23c&scoped=true"
import script from "./AddToQuarantineModal.vue?vue&type=script&lang=js"
export * from "./AddToQuarantineModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af1f23c",
  null
  
)

export default component.exports